var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Material Symbols trending up 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.02459 13.2187C1.87459 13.0687 1.80272 12.8905 1.80897 12.6843C1.81522 12.478 1.88709 12.3062 2.02459 12.1687L5.98084 8.15615C6.26834 7.86865 6.62459 7.7249 7.04959 7.7249C7.47459 7.7249 7.83084 7.86865 8.11834 8.15615L10.0496 10.1062L13.9496 6.24365H12.7496C12.5371 6.24365 12.359 6.17178 12.2152 6.02803C12.0715 5.88428 11.9996 5.70615 11.9996 5.49365C11.9996 5.28115 12.0715 5.10303 12.2152 4.95928C12.359 4.81553 12.5371 4.74365 12.7496 4.74365H15.7496C15.9621 4.74365 16.1402 4.81553 16.284 4.95928C16.4277 5.10303 16.4996 5.28115 16.4996 5.49365V8.49365C16.4996 8.70615 16.4277 8.88428 16.284 9.02803C16.1402 9.17178 15.9621 9.24365 15.7496 9.24365C15.5371 9.24365 15.359 9.17178 15.2152 9.02803C15.0715 8.88428 14.9996 8.70615 14.9996 8.49365V7.29365L11.1183 11.1749C10.8308 11.4624 10.4746 11.6062 10.0496 11.6062C9.62459 11.6062 9.26834 11.4624 8.98084 11.1749L7.04959 9.24365L3.07459 13.2187C2.93709 13.3562 2.76209 13.4249 2.54959 13.4249C2.33709 13.4249 2.16209 13.3562 2.02459 13.2187Z",
    fill: "#14B72E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrending);
export default __webpack_public_path__ + "static/media/Trending.39f2c50802471f33a54f9b6343ffeaf1.svg";
export { ForwardRef as ReactComponent };